import { FC } from 'react';

import { RadioChangeEvent } from 'antd';

import {
  ColSize,
  ContentSection,
  RadioForm,
  RowSize,
} from '../../../../../../../shared/components';
import { PLAN_TYPE } from '../../interfaces';

interface PlanTypeSectionProps {
  nameFormItem: string;
  planType?: string;
  onChange: ((e: RadioChangeEvent) => void) | undefined;
}

export const PlanTypeSection: FC<PlanTypeSectionProps> = ({
  nameFormItem,
  planType,
  onChange,
}) => {
  const OPTION_OPEN_OR_CLOSE: {
    disabled: boolean;
    label: string;
    value: string;
  }[] = [
    {
      disabled: planType?.toUpperCase() === PLAN_TYPE.CLOSED,
      label: 'Abierto',
      value: PLAN_TYPE.OPEN,
    },
    {
      disabled: planType?.toUpperCase() === PLAN_TYPE.OPEN,
      label: 'Cerrado',
      value: PLAN_TYPE.CLOSED,
    },
  ];

  return (
    <ContentSection level='h3' title='Tipo de Plan'>
      <RowSize>
        <ColSize size={25}>
          <RadioForm
            formProps={{
              initialValue: PLAN_TYPE.OPEN,
              label: 'Tipo de Plan',
              name: nameFormItem,
            }}
            options={OPTION_OPEN_OR_CLOSE}
            radioProps={{ onChange: onChange }}
          />
        </ColSize>
      </RowSize>
    </ContentSection>
  );
};
